import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const Label = withDefaultIconProps({ height: 30, width: 30 }, ({ color, ...rest }) => (
  <Svg {...rest} viewBox="0 0 30 30">
    <Path
      d="M19.25 12C20.08 12 20.75 11.33 20.75 10.5C20.75 9.67 20.08 9 19.25 9C18.42 9 17.75 9.67 17.75 10.5C17.75 11.33 18.42 12 19.25 12Z"
      fill={color}
    />
    <Path
      d="M25.63 13.77L25.82 9.09C25.83 8.88 25.75 8.67 25.6 8.52L21.67 4.59C21.53 4.45 21.33 4.37 21.13 4.37H16.26C16.06 4.37 15.87 4.45 15.72 4.59L4.93 15.38C4.21 16.11 4.21 17.3 4.94 18.03L11.97 25.06C12.33 25.42 12.8 25.61 13.3 25.61H13.3C13.8 25.61 14.27 25.41 14.63 25.06L25.41 14.28C25.55 14.14 25.63 13.96 25.63 13.77ZM24.12 13.41L13.54 23.98C13.46 24.07 13.35 24.08 13.3 24.08H13.3C13.24 24.08 13.14 24.07 13.05 23.98L6.02 16.95C5.88 16.81 5.88 16.59 6.02 16.46L16.58 5.89H20.81L24.28 9.36L24.12 13.41Z"
      fill={color}
    />
  </Svg>
));
